module.exports = __webpack_public_path__ + "static/media/Dusk_transparent.ab9900a2.webp";